export default "__VITE_ASSET__NG79InAn__"